import { Tooltip } from "@humansignal/ui";
import { IconInfoOutline } from "@humansignal/icons";
import { cn } from "../../utils/bem";
import "./TabHeader.prefix.css";

const block = cn("tab-header");

/**
 * Shared header used by every tab that sits inside a page layout with its
 * own top chrome — ``OrgPageLayout`` (Overview, Analytics, Workspaces,
 * Quality, Review, Activity, Members, Settings) and ``PlatformPageLayout``
 * (Overview, Users, Orgs, Roles, Audit, Notifications, Settings).
 *
 * The big identity header above is drawn by the layout; this component
 * only renders the per-tab ``h2`` + optional subtitle + optional trailing
 * actions slot. Every tab flipping through the sidebar should look like
 * siblings — same title size, subtitle tone, and horizontal rhythm — so
 * operators feel they're staying on one surface while the body swaps
 * underneath.
 */
export const TabHeader = ({ title, subtitle, actions }) => (
  <header className={block.toClassName()}>
    <div className={block.elem("text").toClassName()}>
      <h2 className={block.elem("title").toClassName()}>
        {title}
        {subtitle && (
          <Tooltip title={<div className={block.elem("tip").toClassName()}>{subtitle}</div>}>
            <button type="button" className={block.elem("info").toClassName()} aria-label="More information">
              <IconInfoOutline />
            </button>
          </Tooltip>
        )}
      </h2>
    </div>
    {actions && <div className={block.elem("actions").toClassName()}>{actions}</div>}
  </header>
);
